import React, { Component } from 'react';
import { Button, ButtonGroup, CustomInput } from 'reactstrap';

import { NPSScoreAnswer, CommentTypeAnswer } from '../answers/answerTypes';

const INCREMENT = 'increment';
const DECREMENT = 'decrement';

class AnswerListDefault extends Component {
  constructor(props) {
    super(props);
    this.state = {
      answers: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      answers: Array.from(Object.create(nextProps.answers)).map(ans => {
        const weight = ans.weight || 0;
        return {
          ...ans,
          weight,
        };
      }),
    });
  }

  assignWeight = (id, action) => {
    let answers = this.state.answers;
    let foundAnswer = answers.find(answer => answer.id === id);
    const index = answers.indexOf(foundAnswer);
    let answer = Object.assign({}, foundAnswer);

    if (!answer) {
      return;
    }

    if (
      (answer.weight === 2 && action === INCREMENT) ||
      (answer.weight === -2 && action === DECREMENT)
    )
      return;

    if (action === INCREMENT) {
      answer.weight = answer.weight + 1;
    } else {
      answer.weight = answer.weight - 1;
    }
    answers[index] = { ...answer };

    this.setState({
      answers,
    });
  };

  render() {
    const { addWeight, answers: realAnswers, inputType } = this.props;

    if (inputType.id == 3) return <CommentTypeAnswer />;

    if (inputType.id == 4) return <NPSScoreAnswer />;

    const { answers } = this.state;

    const answerList = addWeight
      ? answers.map((answer, index) => {
          return (
            <li key={answer.id}>
              <div className="answer-container">
                <div className="weight-block">
                  <div>
                    <Button
                      className="btn btn-default btn-number btn-weights-toggle"
                      onClick={() => this.assignWeight(answer.id, DECREMENT)}
                    >
                      -
                    </Button>
                    <input
                      type="number"
                      className="input-weight"
                      readOnly
                      value={answer.weight}
                    />
                    <Button
                      className="btn btn-default btn-number btn-weights-toggle mr-2"
                      onClick={() => this.assignWeight(answer.id, INCREMENT)}
                    >
                      +
                    </Button>
                  </div>
                </div>
                <div className="float-left">{answer.answer}</div>
              </div>
            </li>
          );
        })
      : realAnswers.map((answer, index) => {
          return (
            <li key={index}>
              <div className="answer-container">
                <div className="d-flex">
                  <div
                    className="text-danger pr-2"
                  >
                    {answer.weight > 0 ? `+${answer.weight}` : answer.weight}
                  </div>
                  <div className="d-flex align-items-center">
                    <CustomInput type={inputType.html_element} inline />
                    {answer.answer}
                  </div>
                </div>
              </div>
            </li>
          );
        });

    return (
      <React.Fragment>
        <ul>{answerList}</ul>
        {addWeight && (
          <div>
            <hr />
            <ButtonGroup className="ml-weight">
              <Button
                className="btn-weights btn-save"
                onClick={() => this.props.saveWeights(answers)}
              >
                Save
              </Button>
              <Button
                className="btn-weights btn-cancel ml-3"
                onClick={this.props.toggleAddWeights}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default AnswerListDefault;



// WEBPACK FOOTER //
// ./src/components/questions/modify/AnswerListDefault.js